// Values starting with "prmd" are temporary keys that will get purged next day
export const LOCAL_STORAGE_KEYS = {
	PRMD: "prmd",
	PRMD_DAY: "prmdDay",
	PRMD_MONTH: "prmdMonth",
	PRMD_CURRENT_LEVEL_INDEX: "prmdCurrentLevelIndex",
	PRMD_CURRENT_LEVEL_LENGTH: "prmdCurrentLevelLength",
	PRMD_LAST_LEVEL_INDEX: "prmdLastLevelIndex",
	PRMD_LAST_LEVEL_LENGTH: "prmdLastLevelLength",
	PRMD_TRIED_WORDS: "prmdTriedWords",
	PRMD_CLUES_SEEN_BY_LEVEL: "prmdCluesSeenByLevel",
	PRMD_TILES: "prmdTiles",
	PRMD_SOLVED: "prmdSolved",
	PRMD_SHOW_CLUES: "showClues",
	PRMD_SHOW_RULES: "showRules",
	PRMD_STATS: "stats",
	// Long-lived list of "YYYY-MM-DD" puzzle dates the player has solved
	// (today's puzzle and any past ones played from the date picker). Used by
	// "Random Day" to avoid re-serving an already-solved puzzle.
	PIRMYD_SOLVED_DATES: "pirmydSolvedDates",
};
